module.exports = __webpack_public_path__ + "static/img/gaozhongdili10.398d321f.jpg";